import * as React from "react";

import { Box, makeStyles, Typography } from "@material-ui/core";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";

import { MopButton } from "client/components";
import { useNormalizedBrandPaletteValues } from "client/hooks/useNormalizedBrandThemeValues";

const useStyles = makeStyles((theme) => {
  const { successBg } = useNormalizedBrandPaletteValues(theme);

  return {
    successIcon: {
      backgroundColor: successBg,
      borderRadius: "50%",
      position: "relative",
    },
    checkmark: {
      width: "100%",
    },
  };
});
interface TabPanelProps {
  index: number;
  value: number;
}

export const TabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  ...other
}) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`scrollable-auto-tabpanel-${index}`}
    aria-labelledby={`scrollable-auto-tab-${index}`}
    {...other}
  >
    {value === index && (
      <Box p={3} pb={0}>
        <Typography component="div">{children}</Typography>
      </Box>
    )}
  </div>
);

export const SuccessIcon: React.FC<{
  size: "small" | "large";
}> = ({ size }) => {
  const classes = useStyles();
  const sizes = {
    small: {
      width: 24,
      height: 24,
    },
    large: {
      width: 40,
      height: 40,
    },
  };

  const { width, height } = sizes[size];
  return (
    <Box width={width} height={height} className={classes.successIcon}>
      <CheckRoundedIcon fontSize={size} className={classes.checkmark} />
    </Box>
  );
};

type SuccessPanelProps = {
  continueToNextStore: () => void;
};

export const SuccessPanel: React.FC<SuccessPanelProps> = ({
  continueToNextStore,
}) => (
  <Box
    alignItems="center"
    display="flex"
    flexDirection="column"
    gridGap={24}
    width="100%"
  >
    <SuccessIcon size="large" />
    <Box>
      <Typography>Store successfully activated!</Typography>
    </Box>
    <Box maxWidth={240}>
      <MopButton
        onClick={continueToNextStore}
        mopVariant="primary"
        fullWidth
        type="submit"
      >
        Continue to next store
      </MopButton>
    </Box>
  </Box>
);
